/**
 * Filters gateway routing entries to those applicable for the checkout currency.
 * Entries without a currency are kept so we don't flash an empty state while
 * routing metadata is still settling after the initial catalog fetch.
 */
export function filterRoutingEntriesByCurrency(routingEntries, currencyCode) {
  const normalizedCurrency = normalizeCurrencyCode(currencyCode);
  return (routingEntries || []).filter((entry) => {
    if (!entry?.paymentMethod || !entry?.platform) return false;
    if (!normalizedCurrency) return true;
    if (!entry.currency) return true;
    return normalizeCurrencyCode(entry.currency) === normalizedCurrency;
  });
}

function normalizeCurrencyCode(value) {
  if (value == null || value === "") return "";
  return String(value).trim().toUpperCase();
}

/** Form map key for the card form that vaults with Altruon (Basis Theory). */
export const ALTRUON_VAULT_CARD_FORM_KEY = "card_altruon_vault";

/**
 * Picks the form component for a routing option ({ method, platform, vaulting }). A card entry
 * whose effective vaulting mode is ALTRUON gets the Altruon vault form; every other option keeps
 * its `${method}_${platform}` form exactly as before.
 */
export function resolvePaymentForm(option, forms) {
  if (!option?.method || !option?.platform) return undefined;
  if (
    option.method === "card" &&
    option.vaulting?.mode === "ALTRUON" &&
    forms[ALTRUON_VAULT_CARD_FORM_KEY]
  ) {
    return forms[ALTRUON_VAULT_CARD_FORM_KEY];
  }
  return forms[`${option.method}_${option.platform}`.toLowerCase()];
}

export function dedupeRoutingOptions(options) {
  return Array.from(
    new Map(
      options.map((opt) => [`${opt.method}_${opt.platform}`, opt])
    ).values()
  );
}
